import { tv } from "../../variants/tv.js";
const actionFooterVariants = tv({
    slots: {
        root: 'w-full rounded-br-[var(--popup-corner-b,0)] rounded-bl-[var(--popup-corner-b,0)] bg-neutral-1/90 shadow-overlay-md backdrop-blur-2xl',
        headerContainer: '',
        contentWrapper: 'px-4 pt-4 pb-2',
        mainContainer: 'flex flex-row items-center justify-between gap-2 pb-2',
        helperTextSlot: 'text-center text-body3'
    },
    variants: {
        barType: {
            bookBar: {
                mainContainer: 'flex flex-row items-center justify-between gap-2 pb-2'
            },
            actionBar: {
                mainContainer: 'flex flex-row items-center justify-between gap-2'
            }
        },
        actionDisplay: {
            lg: {},
            mdRight: {
                mainContainer: 'flex flex-row items-center justify-end gap-2 pb-2'
            },
            mdStacked: {
                mainContainer: 'flex flex-col items-end gap-2 pb-2'
            }
        },
        floating: {
            true: {
                root: 'overflow-clip rounded-2xl shadow-penny-md',
                contentWrapper: 'px-1 pt-1 pb-0'
            },
            false: {}
        }
    },
    compoundVariants: [
        {
            barType: 'bookBar',
            actionDisplay: 'mdRight',
            class: {
                mainContainer: 'flex flex-row items-center justify-start gap-2 pb-2 [&>*:first-child]:mr-auto'
            }
        },
        {
            barType: 'bookBar',
            actionDisplay: 'mdStacked',
            class: {
                mainContainer: 'flex flex-col items-center justify-center gap-2 pb-2'
            }
        },
        {
            floating: true,
            actionDisplay: 'mdRight',
            class: {
                contentWrapper: 'px-1 pt-1 pb-0',
                mainContainer: 'pb-1'
            }
        }
    ],
    defaultVariants: {
        barType: 'actionBar',
        actionDisplay: 'lg',
        floating: false
    }
});
export { actionFooterVariants };
